export default "__VITE_ASSET__wlr5NtqM__"